const Circle2Active = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={31} height={31} x={0.5} y={0.5} rx={15.5} />
    <rect
      width={31}
      height={31}
      x={0.5}
      y={0.5}
      className="stroke-stepper-active-border"
      rx={15.5}
    />
    <path
      className="fill-stepper-active-text-color"
      d="M19.349 19.96V21h-6.515v-.91l3.26-3.63c.402-.446.712-.824.93-1.134a3.54 3.54 0 0 0 .465-.84c.091-.251.137-.507.137-.766 0-.328-.068-.625-.205-.889a1.537 1.537 0 0 0-.588-.643c-.26-.159-.574-.239-.943-.239-.442 0-.812.087-1.108.26-.291.169-.51.406-.656.71a2.414 2.414 0 0 0-.219 1.054h-1.264c0-.56.123-1.074.369-1.538a2.72 2.72 0 0 1 1.093-1.108c.483-.278 1.078-.417 1.785-.417.629 0 1.166.112 1.613.335.447.219.788.529 1.025.93.242.396.363.861.363 1.394 0 .292-.05.588-.15.889a4.51 4.51 0 0 1-.404.889 6.897 6.897 0 0 1-.595.875c-.223.287-.462.57-.718.847l-2.666 2.892h4.99Z"
    />
  </svg>
)
export { Circle2Active }
